module.exports = __webpack_public_path__ + "static/media/login_left_bg.95049640.png";